module.exports = __webpack_public_path__ + "img/window.db96f368.png";